export default {
  title: 'למידע אישי',
  actions: {
    clients: {
      title: 'לקוחות פולאריס',
    },
    shoshana: {
      title: 'לקוחות שושנה שרון שחור',
    },
    guy: {
      title: 'לקוחות גיא אבן טוב',
    },
    itchik: {
      title: 'לקוחות איציק טובי',
    },
  },
};
